import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const karachiNow = () => new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Karachi" }));

const getTarget = () => {
  const now = karachiNow();
  const thisYear = new Date(now.getFullYear(), 7, 22);
  return now > thisYear ? new Date(now.getFullYear() + 1, 7, 22) : thisYear;
};

const isBirthdayToday = () => {
  const now = karachiNow();
  return now.getMonth() === 7 && now.getDate() === 22;
};

const UNITS = [
  { key: "days", label: "Days", testId: "countdown-days" },
  { key: "hours", label: "Hours", testId: "countdown-hours" },
  { key: "minutes", label: "Minutes", testId: "countdown-minutes" },
  { key: "seconds", label: "Seconds", testId: "countdown-seconds" },
];

export default function CountdownTimer() {
  const [now, setNow] = useState(() => karachiNow());

  useEffect(() => {
    const tick = setInterval(() => setNow(karachiNow()), 1000);
    return () => clearInterval(tick);
  }, []);

  if (isBirthdayToday()) {
    return (
      <motion.p
        data-testid="countdown-timer"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="mt-10 text-4xl sm:text-5xl text-[#E30B5C]"
        style={{ fontFamily: "'Caveat', cursive" }}
      >
        gen1 din agya, enjoy karen
      </motion.p>
    );
  }

  const diff = Math.max(0, getTarget() - now);
  const values = {
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    minutes: Math.floor(diff / 60000) % 60,
    seconds: Math.floor(diff / 1000) % 60,
  };

  return (
    <motion.div
      data-testid="countdown-timer"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, delay: 0.6 }}
      className="mt-10"
    >
      <p className="text-sm uppercase tracking-[0.2em] font-medium text-[#E30B5C] mb-4">
        Counting down to your day
      </p>
      <div className="flex items-center justify-center gap-3 sm:gap-4">
        {UNITS.map((u) => (
          <div
            key={u.key}
            data-testid={u.testId}
            className="w-[72px] sm:w-[92px] rounded-2xl border border-white/40 bg-white/60 backdrop-blur-xl py-3 sm:py-4 shadow-[0_8px_24px_rgba(227,11,92,0.12)]"
          >
            <div className="text-2xl sm:text-4xl font-bold text-[#E30B5C] tabular-nums">
              {String(values[u.key]).padStart(2, "0")}
            </div>
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] text-[#5C404C] mt-1">
              {u.label}
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
